import { collection, onSnapshot, query, where } from "firebase/firestore";
import { useEffect, useState } from "react";
import { db } from "../firebase/client";

export function useGoalScorers(broadcastId: string | null): Map<number, number> {
	const [scorers, setScorers] = useState<Map<number, number>>(new Map());

	useEffect(() => {
		if (!broadcastId) return;

		const q = query(
			collection(db, "broadcasts", broadcastId, "posts"),
			where("type", "==", "goal"),
		);

		const unsubscribe = onSnapshot(q, (snapshot) => {
			const counts = new Map<number, number>();
			for (const doc of snapshot.docs) {
				const scorerId = doc.data().scorerId as number | null | undefined;
				if (scorerId != null) {
					counts.set(scorerId, (counts.get(scorerId) ?? 0) + 1);
				}
			}
			setScorers(counts);
		});

		return unsubscribe;
	}, [broadcastId]);

	return scorers;
}
